import Vue from "vue";

Vue.filter('dayString', function (value) {
    if(!value) {
        return value;
    }
    return value === 1 ? `${value} day` : `${value} days`;
});
